import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model): string =>
	item.additionalFields?.executorNotes || item.orderNote || "";

export default cellProcessing;
